
import { createContext, useReducer } from "react";
import AgenceReducer from "./AgenceReducer";

const INITIAL_STATE = {
    agencesByWilaya: [],
};


export const AgenceContext = createContext(INITIAL_STATE);

export const AgenceContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(AgenceReducer, INITIAL_STATE);
    
    return (
      <AgenceContext.Provider
        value={{
          agencesByWilaya: state.agencesByWilaya,
          dispatch,
        }}
      >
        {children}
      </AgenceContext.Provider>
    );
  };